export default {
    data() {
        return {
            isCartRemoveIconActive: false,
            quantityCartItem: 0,
        };
    },
    mounted() {
        if (this.cashOfferCartCount !== this.offerCartCount) {
            this.quantityCartItem = this.offerCartCount;
            localStorage.setItem(`${this.offer?.id}_cash` , this.offerCartCount);
            localStorage.setItem(this.offer?.id , this.quantityCartItem);
        } else {
            this.quantityCartItem = (this.storageQuantityCartItem) ? this.storageQuantityCartItem : this.offerCartCount;
            localStorage.setItem(`${this.offer?.id}_cash` , this.offerCartCount);
        }
    },
    computed: {
        cashOfferCartCount() {
            return Number(localStorage.getItem(`${this.offer?.id}_cash`));
        },
        storageQuantityCartItem() {
            return Number(localStorage.getItem(this.offer?.id));
        },
        offerCart() {
            if (this.$configuration.offerCartCount) {
                return this.$configuration.offerCartCount.filter(offer => offer?.id === this.offer?.id);
            }
            return false;
        },
        offerCartCount() {
            if (this.offerCart) {
                return (this.offerCart.length) ? this.offerCart[0].count : 0;
            }
            return 0;
        },
        quantityCartItemSum() {
            if (this.offerCart) {
                return (this.offerCart.length) ? this.offerCart[0].sum : false;
            }
            return false;
        },
    },
    methods: {
        emitsQuery(payload, actionName) {
            const { id, name, price , prices } = payload;
            localStorage.setItem(id , this.quantityCartItem);
            this.$emit( actionName, {
                id: id,
                name: (name || '').replace(/<\/?[^>]+(>|$)/g, ''),
                price: parseFloat(price),
                prices: prices,
                quantity: this.quantityCartItem,
                img: (this.offer?.pictures) ? this.offer?.pictures[0] : (this.data) ? this.data?.image_url : null,
            });
        },
        plusCart() {
            if (this.quantityCartItemSum > this.quantityCartItem) {
                this.quantityCartItem++;
            } else if (!this.quantityCartItemSum && this.quantityCartItemSum !== 0) {
                this.quantityCartItem++;
            }
        },

        minusCart() {
            if (this.quantityCartItem > 0) {
                this.quantityCartItem--;
            }
        },
        addToCart(payload = {}) {
            this.emitsQuery(payload , 'add-to-cart');
        },
    },
};
